var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 22.5C7.36875 22.5 6.2625 23.6187 6.2625 25C6.2625 26.3813 7.36875 27.5 8.75 27.5C10.1313 27.5 11.25 26.3813 11.25 25C11.25 23.6187 10.1313 22.5 8.75 22.5ZM1.25 2.5V5H3.75L8.24375 14.4812L6.55625 17.5437C6.3625 17.9062 6.25 18.3125 6.25 18.75C6.25 20.1313 7.36875 21.25 8.75 21.25H23.75V18.75H9.28125C9.10625 18.75 8.96875 18.6125 8.96875 18.4375C8.96875 18.3813 8.98125 18.3313 9.00625 18.2875L10.125 16.25H19.4375C20.375 16.25 21.1937 15.7313 21.625 14.9625L26.0938 6.85C26.1938 6.675 26.25 6.46875 26.25 6.25C26.25 5.91848 26.1183 5.60054 25.8839 5.36612C25.6495 5.1317 25.3315 5 25 5H6.51875L5.33125 2.5H1.25ZM21.25 22.5C19.8687 22.5 18.7625 23.6187 18.7625 25C18.7625 26.3813 19.8687 27.5 21.25 27.5C22.6313 27.5 23.75 26.3813 23.75 25C23.75 23.6187 22.6313 22.5 21.25 22.5Z",
    fill: "#475168"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon3);
export default __webpack_public_path__ + "static/media/cart-icon3.e079191b0228ac9c67e7532ca88cae12.svg";
export { ForwardRef as ReactComponent };